export default __webpack_public_path__ + "static/media/19.9b8b4149.svg";